"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XSOLLA_LOCALE_TO_LANGUAGE_TYPE = exports.LANGUAGE_TYPE_TO_XSOLLA_LOCALE = void 0;
const shared_1 = require("@lifeserver/shared");
const LANGUAGE_AND_XSOLLA_LOCALE_PAIRS = [
    [shared_1.LanguageType.English, 'en'],
    [shared_1.LanguageType.Arabic, 'ar'],
    [shared_1.LanguageType.Chinese, 'cn'],
    [shared_1.LanguageType.ChineseTraditional, 'tw'],
    [shared_1.LanguageType.French, 'fr'],
    [shared_1.LanguageType.German, 'de'],
    [shared_1.LanguageType.Indonesian, 'id'],
    [shared_1.LanguageType.Italian, 'it'],
    [shared_1.LanguageType.Japanese, 'ja'],
    [shared_1.LanguageType.Korean, 'ko'],
    [shared_1.LanguageType.Polish, 'pl'],
    [shared_1.LanguageType.PortugueseBrazil, 'pt'],
    [shared_1.LanguageType.Russian, 'ru'],
    [shared_1.LanguageType.Spanish, 'es'],
    [shared_1.LanguageType.Thai, 'th'],
    [shared_1.LanguageType.Turkish, 'tr'],
];
exports.LANGUAGE_TYPE_TO_XSOLLA_LOCALE = Object.fromEntries(LANGUAGE_AND_XSOLLA_LOCALE_PAIRS);
exports.XSOLLA_LOCALE_TO_LANGUAGE_TYPE = Object.fromEntries(LANGUAGE_AND_XSOLLA_LOCALE_PAIRS.map(([language, xsollaLocale]) => [
    xsollaLocale,
    language,
]));
